/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KuendigungInputs */

const de__field_kuendigung = /** @type {(inputs: _Field_KuendigungInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigung`)
};

/**

* @param {_Field_KuendigungInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kuendigung = /** @type {((inputs?: _Field_KuendigungInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KuendigungInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kuendigung(inputs)
});